var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawServerDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 172,
    viewBox: "0 0 276 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4417_69077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.1324 104.824C101.132 104.824 124.64 81.3584 124.64 52.412C124.64 23.4657 101.132 0 72.1324 0C43.1333 0 19.6248 23.4657 19.6248 52.412C19.6248 81.3584 43.1333 104.824 72.1324 104.824Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5845C0 31.6541 11.9851 47.0849 26.7963 47.0849L0 12.5845Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7963 47.0849C26.7963 27.801 40.171 12.1968 56.6995 12.1968L26.7963 47.0849Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70881 14.313C9.70881 32.4271 17.3515 47.0847 26.7963 47.0847L9.70881 14.313Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7963 47.0848C26.7963 22.4444 42.2553 2.50562 61.3597 2.50562L26.7963 47.0848Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1591 47.328C21.1591 47.328 24.9592 47.2112 26.1045 46.3971C27.2498 45.5831 31.9501 44.6111 32.2342 45.9166C32.5183 47.2222 37.9451 52.4098 33.6548 52.4444C29.3644 52.4789 23.6859 51.7773 22.5428 51.0823C21.3998 50.3873 21.1591 47.328 21.1591 47.328Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M33.7314 51.9901C29.441 52.0247 23.7625 51.323 22.6194 50.628C21.7489 50.0987 21.402 48.1995 21.2859 47.3232C21.2056 47.3267 21.1591 47.3282 21.1591 47.3282C21.1591 47.3282 21.3998 50.3874 22.5428 51.0825C23.6859 51.7775 29.3644 52.4791 33.6548 52.4446C34.8932 52.4346 35.321 51.9948 35.2975 51.3433C35.1255 51.7369 34.6531 51.9827 33.7314 51.9901Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.96 110.715C74.4194 110.715 95.0583 107.912 95.0583 104.455C95.0583 100.998 74.4194 98.1951 48.96 98.1951C23.5007 98.1951 2.86182 100.998 2.86182 104.455C2.86182 107.912 23.5007 110.715 48.96 110.715Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M48.9601 109.71C70.335 109.71 87.6628 107.357 87.6628 104.455C87.6628 101.552 70.335 99.1992 48.9601 99.1992C27.5851 99.1992 10.2573 101.552 10.2573 104.455C10.2573 107.357 27.5851 109.71 48.9601 109.71Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.236 172C244.766 172 276 167.759 276 162.527C276 157.294 244.766 153.053 206.236 153.053C167.707 153.053 136.473 157.294 136.473 162.527C136.473 167.759 167.707 172 206.236 172Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5697 164.526C99.7145 164.526 118.477 161.979 118.477 158.836C118.477 155.693 99.7145 153.145 76.5697 153.145C53.4248 153.145 34.6622 155.693 34.6622 158.836C34.6622 161.979 53.4248 164.526 76.5697 164.526Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.04 154.037C136.226 159.697 178.873 146.655 183.557 131.891",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3232 63.7309C76.3232 63.7309 108.37 54.8726 110.342 83.4162C112.314 111.96 83.9651 120.08 106.151 125.74",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3615 132.207C45.3615 132.207 54.9934 129.545 55.5861 138.124C56.1789 146.703 47.6583 149.143 54.3266 150.844",
    stroke: "#2F2E41",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.962 138.594L190.02 150.97C190.02 150.97 180.46 156.04 187.182 156.189C193.904 156.338 225.572 156.189 225.572 156.189C225.572 156.189 231.697 156.189 221.987 150.821L220.045 137.849L191.962 138.594Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.83 156.055C187.356 154.699 190.02 153.286 190.02 153.286L191.962 140.91L220.045 140.936L221.987 153.137C224.252 154.388 225.654 155.348 226.475 156.084C227.722 155.8 229.085 154.745 221.987 150.821L220.045 137.849L191.962 138.594L190.02 150.97C190.02 150.97 181.987 155.231 185.83 156.055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.668 52.3354H147.041C144.584 52.3354 142.592 54.3235 142.592 56.7759V135.868C142.592 138.321 144.584 140.309 147.041 140.309H264.668C267.125 140.309 269.117 138.321 269.117 135.868V56.7759C269.117 54.3235 267.125 52.3354 264.668 52.3354Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.859 57.0322H146.849V122.938H264.859V57.0322Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.854 55.6903C206.267 55.6903 206.601 55.3565 206.601 54.9448C206.601 54.533 206.267 54.1992 205.854 54.1992C205.442 54.1992 205.107 54.533 205.107 54.9448C205.107 55.3565 205.442 55.6903 205.854 55.6903Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.117 128.156V135.868C269.117 136.451 269.002 137.029 268.778 137.568C268.555 138.106 268.227 138.596 267.814 139.008C267.401 139.421 266.91 139.748 266.37 139.971C265.831 140.194 265.252 140.309 264.668 140.309H147.041C146.456 140.309 145.878 140.194 145.338 139.971C144.798 139.748 144.308 139.421 143.895 139.008C143.482 138.596 143.154 138.106 142.931 137.568C142.707 137.029 142.592 136.451 142.592 135.868V128.156H269.117Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.867 164.24V165.732H158.501V164.539L158.612 164.24L160.592 158.873H237.224L238.867 164.24Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.795 162.781C269.648 163.406 269.096 164.065 267.847 164.688C263.365 166.925 254.253 164.092 254.253 164.092C254.253 164.092 247.232 162.899 247.232 159.767C247.43 159.633 247.635 159.511 247.848 159.402C249.732 158.407 255.979 155.952 267.056 159.506C267.872 159.762 268.601 160.239 269.161 160.883C269.61 161.408 269.962 162.073 269.795 162.781Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M269.795 162.781C264.31 164.879 259.42 165.035 254.403 161.557C251.872 159.803 249.573 159.369 247.848 159.402C249.732 158.407 255.979 155.952 267.056 159.506C267.872 159.762 268.601 160.239 269.161 160.883C269.61 161.408 269.962 162.073 269.795 162.781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.917 161.557C263.99 161.557 264.859 161.29 264.859 160.96C264.859 160.631 263.99 160.364 262.917 160.364C261.845 160.364 260.975 160.631 260.975 160.96C260.975 161.29 261.845 161.557 262.917 161.557Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.854 137.103C207.422 137.103 208.693 135.835 208.693 134.27C208.693 132.705 207.422 131.437 205.854 131.437C204.287 131.437 203.016 132.705 203.016 134.27C203.016 135.835 204.287 137.103 205.854 137.103Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M238.867 164.24V165.732H158.501V164.539L158.612 164.24H238.867Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0488 39.1245H26.7737V98.6724H78.0488V39.1245Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2256 33.219H21.5969V54.3807H83.2256V33.219Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2256 58.3176H21.5969V79.4793H83.2256V58.3176Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2256 83.4163H21.5969V104.578H83.2256V83.4163Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M70.8998 36.9099H66.9556V40.847H70.8998V36.9099Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M76.5697 36.9099H72.6254V40.847H76.5697V36.9099Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2395 36.9099H78.2953V40.847H82.2395V36.9099Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M70.8998 61.7625H66.9556V65.6995H70.8998V61.7625Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M76.5697 61.7625H72.6254V65.6995H76.5697V61.7625Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2395 61.7625H78.2953V65.6995H82.2395V61.7625Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M70.8998 86.6152H66.9556V90.5523H70.8998V86.6152Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M76.5697 86.6152H72.6254V90.5523H76.5697V86.6152Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2395 86.6152H78.2953V90.5523H82.2395V86.6152Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0488 151.822C88.8043 151.822 97.5234 143.119 97.5234 132.383C97.5234 121.647 88.8043 112.944 78.0488 112.944C67.2932 112.944 58.5741 121.647 58.5741 132.383C58.5741 143.119 67.2932 151.822 78.0488 151.822Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0906 147.639H69.1742V158.22H75.0906V147.639Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9233 147.639H81.0069V158.22H86.9233V147.639Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1045 160.189C76.8275 160.189 79.0348 159.363 79.0348 158.343C79.0348 157.324 76.8275 156.498 74.1045 156.498C71.3816 156.498 69.1742 157.324 69.1742 158.343C69.1742 159.363 71.3816 160.189 74.1045 160.189Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9372 159.943C88.6602 159.943 90.8675 159.116 90.8675 158.097C90.8675 157.078 88.6602 156.252 85.9372 156.252C83.2143 156.252 81.0069 157.078 81.0069 158.097C81.0069 159.116 83.2143 159.943 85.9372 159.943Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5418 134.106C82.2178 134.106 85.1977 131.131 85.1977 127.462C85.1977 123.793 82.2178 120.818 78.5418 120.818C74.8659 120.818 71.8859 123.793 71.8859 127.462C71.8859 131.131 74.8659 134.106 78.5418 134.106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5418 129.677C79.7671 129.677 80.7604 128.685 80.7604 127.462C80.7604 126.239 79.7671 125.248 78.5418 125.248C77.3165 125.248 76.3232 126.239 76.3232 127.462C76.3232 128.685 77.3165 129.677 78.5418 129.677Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1577 114.306C57.5852 107.276 62.6118 100.173 70.385 98.4406C78.1581 96.7081 85.7342 101.002 87.3067 108.032C88.8792 115.061 83.7277 117.654 75.9545 119.386C68.1814 121.119 60.7302 121.335 59.1577 114.306Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3141 128.506C101.258 126.394 104.727 123.426 104.063 121.877C103.399 120.327 98.8525 120.784 93.9085 122.896C88.9645 125.008 85.4952 127.976 86.1595 129.526C86.8237 131.075 91.3701 130.618 96.3141 128.506Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8299 141.548C64.7739 139.436 68.2433 136.467 67.579 134.918C66.9147 133.369 62.3683 133.825 57.4243 135.938C52.4804 138.05 49.011 141.018 49.6753 142.567C50.3396 144.116 54.886 143.66 59.8299 141.548Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3884 138.043C89.3884 139.945 84.4807 143.702 79.0348 143.702C73.589 143.702 68.4347 140.191 68.4347 138.289C68.4347 136.386 73.589 136.813 79.0348 136.813C84.4807 136.813 89.3884 136.14 89.3884 138.043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4417_69077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 276,
    height: 172,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawServerDown);
export default __webpack_public_path__ + "static/media/undraw-server-down.62d88127174d80e343f2711a76ab7d14.svg";
export { ForwardRef as ReactComponent };